<template>
    <SmartLinkItemComponent custom-tag="div" class="publication-list" v-if="model" :id="`_${model.system.id}`"
        :component="!model.system.workflow">
        <div class="container">
            <div class="row">
                <div class="col-lg-2">
                    <div class="sort-col">
                        <div class="heading" @click="visible = !visible">
                            Sort by
                            <IconChevronUp class="icon-chevron-up" :class="[visible ? '' : 'rotate-180']">
                            </IconChevronUp>
                        </div>
                        <div v-show="visible">
                            <template v-for="(item) in options" :key="item.id">
                                <label class="radio">
                                    <input type="radio" :name="`sfilter_${item.id}`" v-model="sortModel"
                                        :value="item.id" @change="sort()" />
                                    <span class="custom-radio" :for="`sfilter_${item.id}`"></span>{{ item.title }}
                                </label><br>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-lg">
                    <div class="results-col">
                        <PublicationItem v-for="item in source" :model="item" />
                        <button class="btn btn-link" v-if="allowShowMore" @click="loadData()">
                            Load More
                            <IconChevronDown class="icon-chevron-down"></IconChevronDown>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { type PublicationItemModel, type PublicationListModel } from '~/models';


const options = [
    { id: 0, title: 'Newest First' },
    { id: 1, title: 'Oldest First' },
    { id: 2, title: 'Title A-Z' },
]

// START: Toggles the collapse and expand of Sorting Col based on media query
const visible = ref(true);
function handleResize() {
    visible.value = window.matchMedia('(max-width: 991px)').matches ? false : true;
}

onMounted(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});

const props = defineProps<{ model: PublicationListModel }>();

const data = computed(() => {
    return {
        numberOfItens: props.model.elements.numberOfItemsToDisplay.value
    }
});

const sortModel = ref(0);
const source: Ref<PublicationItemModel[]> = ref([]);
const totalCount = ref(0)
const lastAddIndex = ref(1);
const limit:Ref<number> = ref(0)
const allowShowMore = computed(() => totalCount.value > limit.value)
await loadData();

async function loadData(increaseIdx: number = 0) {
    // handle when sorting
    lastAddIndex.value += increaseIdx;

    const lValue = (lastAddIndex.value) * (data.value.numberOfItens ?? 3); 
    limit.value = lValue
    const response = await useFetch(`/api/publication-list?limit=${lValue}&orderBy=${sortModel.value}`);

    totalCount.value = response.data.value?.data?.totalCount ?? 0;
    
    source.value = response.data.value?.data?.item ?? [];
    lastAddIndex.value++;
}

function sort() {
    loadData(-1);
}

</script>
